module.exports = __webpack_public_path__ + "img/loadingDot.0f66f5a5.svg";